<template>
  <div class="result-success-wrapper" :style="{'padding-bottom': safePadding + 'px'}">
    <img src="../../assets/crf/gift.png" alt="">
    <div class="desc1">问卷提交成功</div>
    <div class="desc2">感谢您的耐心反馈</div>
    <div class="desc3" v-html="txt"></div>
    <div class="btn" @click="close">我知道了</div>
  </div>
  
</template>

<script>
export default {
  name: 'ResultSuccess',
  props: {
    coupon: {
      type: String,
      default: ''
    }
  },
  computed: {
    safePadding() {
      return 36 + (+(this.$route.query.safeBottom || 0))
    },
    txt() {
      return this.coupon?.replace('\n', '<br>')
    }
  },
  data() {
    return {
    };
  },
  methods: {
    close() {
      this.$emit('iknow')
    }
  }
}
</script>

<style lang="scss" scoped>
.result-success-wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 28px;
  color: #3A3B3C;
  background: #fff;
  border-radius: 24px 24px 0 0;
  img {
    width: 240px;
    height: 240px;
    margin-top: 64px;
  }
  .desc1 {
    color: #89898A;
    margin-top: 24px;
  }
  .desc2 {
    font-weight: 500;
    font-size: 32px;
    line-height: 44px;
    margin-top: 16px;
    font-family: PingFangSC, PingFang SC;
  }
  .desc3 {
    margin-top: 64px;
    :deep(b) {
      font-weight: 500;
      color: #FF583E;
    }
  }
  .btn {
    width: 326px;
    height: 88px;
    line-height: 88px;
    background: linear-gradient(153deg, #FF7673 0%, #FF3D3D 100%);
    border-radius: 48px;
    font-weight: 500;
    color: #FFFFFF;
    margin: 80px auto 40px;
  }
}

</style>
